window.addEventListener('alpine:init', bootstrap);
export default () => ({
});

function bootstrap() {
	document.querySelectorAll('.js-accordion').forEach(
		$$ => bootstrapAccordion($$)
	);
}

function bootstrapAccordion($el) {
	$el.setAttribute('x-data', 'accordion');

	$el.querySelectorAll('.js-accordion-item').forEach(
		$$ => bootstrapAccordionItem($$)
	);
}

function bootstrapAccordionItem($el) {
	$el.setAttribute('x-data', '{ expanded: false }');
	$el.setAttribute(':class', '{ "is-expanded": expanded }');

	const $title = $el.querySelector('.vcex-teaser-heading');
	if ( $title ) {
		$title.setAttribute('x-on:click', 'expanded = !expanded');
	}

	const $content = $el.querySelector('.vcex-teaser-text');
	if ( $content ) {
		$content.setAttribute('x-show', 'expanded');
		$content.setAttribute('x-collapse', '');
	}
}
